"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/dex/errors.ts
var UnmatchedPtonVersion = class extends Error {
  constructor({
    expected,
    received
  }) {
    super(
      `The version of the provided pTON (${received}) does not match the expected version (${expected})`
    );
  }
};



exports.UnmatchedPtonVersion = UnmatchedPtonVersion;
//# sourceMappingURL=chunk-NDXEUKBX.cjs.map